export default __webpack_public_path__ + "thickener.png?771ced9d3563d57b1b9449cc4f3c62b7";